import { Flex, Heading } from "@chakra-ui/react";
import React from "react";

const HeadingCompo = ({ children }) => {
  return (
    <Flex justify="center">
      <Heading color="#fff" textShadow="2px 2px 5px teal">
        {children}
      </Heading>
    </Flex>
  );
};

export default HeadingCompo;
